import { render } from "./loginForm.vue?vue&type=template&id=4fa45565"
import script from "./loginForm.vue?vue&type=script&lang=js"
export * from "./loginForm.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\stall\\Documents\\Projects\\Web Apps\\Appleton\\vue agencyflow\\vue-agencyflow\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__